import AbstractListView from '@UI/Store/AbstractListView';
import type AiProviderView from '@UI/Store/AiConfiguration/Views/AiProviderView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `scopeId` names the account this catalogue belongs to. Every list View in this store names its
 * periphery the same way, `scopeId`, even where it is an account: a screen combining several of them
 * writes one `stopOn` shape, not one per entity.
 */
class AiProvidersListView extends AbstractListView<AiProviderView> {
	readonly scopeId: number;

	constructor(list: readonly AiProviderView[], scopeId: number) {
		super(list, 'AiProvidersListView');

		this.scopeId = scopeId;

		Object.freeze(this);
	}

	add(provider: AiProviderView): AiProvidersListView {
		return new AiProvidersListView([...this.list, provider], this.scopeId);
	}

	update(provider: AiProviderView): AiProvidersListView {
		return new AiProvidersListView(
			this.list.map((entry) => (entry.id === provider.id ? provider : entry)),
			this.scopeId,
		);
	}

	remove(providerId: number): AiProvidersListView {
		return new AiProvidersListView(
			this.list.filter((entry) => entry.id !== providerId),
			this.scopeId,
		);
	}
}

export default AiProvidersListView;
